export const photosProduitsSizes = [100, 200, 300, 600];
export const photosActualitesSizes = photosProduitsSizes;
